import axios from "axios";
import Config from "../../../src/utils/config/config"
import { Headers } from "../../utils/config/configHelpers";

const configHeaders = () => {
  return {
    headers: Headers()
  }
};

const baseUrl = Config.gRPCURL 

const AgentGuardServiceClient = {
  execute: async (agInput) => {
    const url = `${baseUrl}/grpc/agentguard.AgentGuardService/Execute`;

    const response = await axios.post(url, agInput, configHeaders());

    let content = response.data?.content;

    if (typeof content === "string") {
      response.data.content = JSON.parse(content);
    } else if (Array.isArray(content) && content[0]) {
      response.data.content = [JSON.parse(content[0])];
    }

    return response.data;
  },
};

export default AgentGuardServiceClient;
